module.exports = __webpack_public_path__ + "resources/img/equipment_tab_img3.c1582ccd004b82b36dde1c49a334b021.jpg";